import { useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import Icon from 'components/Icon';

export default function Navbar() {
  const [open, setOpen] = useState(false);
  return (
    <nav className="nav">
      <div className="container nav-inner">
        <Link to="/" className="nav-logo">
          <div className="nav-logo-box"><Icon name="logo" size={18} /></div>
          <span className="nav-logo-text">Dev<span>layar</span></span>
        </Link>

        {/* Admin link is COMPLETELY REMOVED from navbar */}
        <ul className={`nav-links ${open ? 'open' : ''}`} onClick={() => setOpen(false)}>
          <li><NavLink to="/"><Icon name="home" size={15} />Home</NavLink></li>
          <li><NavLink to="/tools"><Icon name="tools" size={15} />Tools</NavLink></li>
          <li><NavLink to="/blog"><Icon name="blog" size={15} />Blog</NavLink></li>
        </ul>

        <button className="hamburger" onClick={() => setOpen(v => !v)} aria-label="Menu">
          <span /><span /><span />
        </button>
      </div>
    </nav>
  );
}
